import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const AsyncHome = () => import("../views/Home.vue");
const Valentine = () => import("../views/ValentinePage.vue");

const routes = [
  {
    path: "/",
    name: "valentine",
    component: Valentine,
  },
  {
    path: "/support",
    name: "Support",
    component: AsyncHome,
    children: [
      {
        path: "/",
        component: () => import("../components/MainPageComponents.vue"),
      },
    ],
  },
  {
    path: "/error",
    name: "Error",
    component: () => import("../views/Error.vue"),
  },

  {
    path: "/404",
    component: () => import("../views/PageNotFound.vue"),
  },
  {
    path: "*",
    component: () => import("../views/PageNotFound.vue"),
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

export default router;
